import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {RulesService} from '../../rules.service';
import {RuleModel} from '../../model/RuleModel';
import {NotificationBarService} from '../../../core/notify/notification.service';
import {NotificationType} from '../../../core/notify';
import {SpinnerService} from '../../../core/spinner/spinner.service';

@Component({
  selector: 'app-rule-table',
  templateUrl: './rule-table.component.html',
  styleUrls: ['./rule-table.component.scss']
})
export class RuleTableComponent implements OnInit {

  @Input() data;
  @Input() page;
  @Output() deleteRule: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor(private ruleService: RulesService,
              private notifier: NotificationBarService,
              private spinner: SpinnerService) { }

  ngOnInit() {
  }

  edit(rule: RuleModel) {
    this.ruleService.navigateToEditRule(rule);
  }

  goToDetails(rule: RuleModel) {
    this.ruleService.navigateToDetails(rule);
  }

  delete(rule) {
    this.spinner.show();
    this.ruleService.deleteRule(rule.id)
      .subscribe(res => {
        this.spinner.hide();
        this.notifier.create({message: 'Rule has been deleted successfully', type: NotificationType.Success});
       this.deleteRule.emit(true);
        }, err => this.spinner.hide());
  }
}



// WEBPACK FOOTER //
// ./src/app/rules/rules-list/rule-table/rule-table.component.ts